<angular-cropper
  #angularCropper
  [cropperOptions]="config"
  [imageUrl]="imageData"></angular-cropper>
